import React, { PropsWithChildren, useMemo } from 'react';
import useLayoutStyles from './styles';
import ScreenLayoutIcon from './ScreenLayoutIcon';
import ScreenLayoutList from './ScreenLayoutList';
import ScreenLayoutsModel from './ScreenLayoutsModel';
type ScreenLayoutProps = PropsWithChildren<{}>;
const Root = ({ children }: ScreenLayoutProps) => <>{children}</>;
const ScreenSelectLayout: React.FunctionComponent = (props) => {
  const classes = useLayoutStyles(props);
  const areas = Array(4).fill({
    columns: 6,
    rows: 6,
  });

  const renderScreenLayoutIcon = useMemo(() => {
    return areas.map((area, index) => (
      <ScreenLayoutIcon
        key={`layoutArea_${area.columns}${area.rows}${index}`}
        area={area}
        index={index}
      />
    ));
  }, [areas]);

  return <div className={classes.container}>{renderScreenLayoutIcon}</div>;
};

Root.ScreenSelectLayout = ScreenSelectLayout;
Root.ScreenLayoutList = ScreenLayoutList;
Root.ScreenLayoutsModel = ScreenLayoutsModel;

export const ScreenLayout = Root;
